import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import { CertificateService } from 'app/services/models/certificate.service';
import { CompanyService } from 'app/services/models/company.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-certificate-reservation-dialog',
  templateUrl: './certificate-reservation-dialog.component.html',
  styleUrls: ['./certificate-reservation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CertificateReservationDialogComponent implements OnInit {
  @Input() data;
  companies: any[];
  certificateForm: FormGroup;
  isSeriesAdd: boolean = false;
  reservationNumbers: string[] = []; // Aralıktaki numaraları saklayacak liste

  constructor(
    public activeModal: NgbActiveModal,
    private companyService: CompanyService,
    private fb: FormBuilder,
    private certificateReservationService: CertificateReservationService,
    private toastrService: ToastrService,
    private certificateService:CertificateService
  ) { }

  async ngOnInit() {
    console.log(this.data);
    this.certificateForm = this.fb.group({
      reservationNo: [
        '',
        [
          Validators.required,
          Validators.pattern(`^${new Date().getFullYear()}\\d{5}$`) // Örn: 202500001
        ]
      ],
      endReservationNo: [null, Validators.pattern(`^${new Date().getFullYear()}\\d{5}$`)],
      companyId: [null, Validators.required]
    });
    await this.getAllCompanies();
    await this.getLastCertificateNo();
    if (this.data) {
      this.certificateForm.patchValue({
        reservationNo: this.data.reservedCertificateNo,
        companyId: this.data.companyId
      })
    }
  }

  async getLastCertificateNo(){
    const data = await this.certificateService.getLastCertificate();
    this.certificateForm.patchValue({
      reservationNo:data
    })
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  toggleSeries() {
    this.isSeriesAdd = !this.isSeriesAdd;
    if (this.isSeriesAdd) {
      this.certificateForm.get('endReservationNo')?.setValidators([
        Validators.required,
        Validators.pattern(`^${new Date().getFullYear()}\\d{5}$`)
      ]);
    } else {
      this.certificateForm.get('endReservationNo')?.clearValidators();
    }
    this.certificateForm.get('endReservationNo')?.updateValueAndValidity();
  }

  generateReservationNumbers() {
    this.reservationNumbers = []; // Önceki listeyi temizle

    const start = Number(this.certificateForm.value.reservationNo);
    const end = Number(this.certificateForm.value.endReservationNo);

    if (this.isSeriesAdd && start && end && end >= start) {
      for (let i = start; i <= end; i++) {
        this.reservationNumbers.push(i.toString());
      }
      console.log("Oluşturulan numaralar:", this.reservationNumbers);
    }
  }

  async onSubmit() {
    if (this.certificateForm.valid) {
      if (this.data) {
        const data = await this.certificateReservationService.updateCertificateReservation(this.data.id, this.certificateForm.value.companyId, this.certificateForm.value.reservationNo);
        if (data.status) {
          this.toastrService.success(data.message);
          this.certificateReservationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        if (!this.isSeriesAdd) {
          console.log(this.certificateForm.value)
          this.reservationNumbers.push(this.certificateForm.value.reservationNo.toString());
          console.log(this.reservationNumbers);
          const data = await this.certificateReservationService.createCertificateReservation(this.certificateForm.value.companyId, this.reservationNumbers);
          if (data.status) {
            this.toastrService.success(data.message,'',{ timeOut: 10000, extendedTimeOut: 2000 });
            this.certificateReservationService.sendEvent(true);
            this.closeModal();
          } else {
            this.toastrService.error(data.message);
          }
        } else {
          this.generateReservationNumbers();
          const data = await this.certificateReservationService.createCertificateReservation(this.certificateForm.value.companyId, this.reservationNumbers);
          if (data.status) {
            this.toastrService.success(data.message,'',{ timeOut: 10000, extendedTimeOut: 2000 });
            this.certificateReservationService.sendEvent(true);
            this.closeModal();
          } else {
            this.toastrService.error(data.message,'',{ timeOut: 10000, extendedTimeOut: 2000 });
          }
        }
      }
    }
  }
}


/*
 console.log("Form Değerleri:", this.certificateForm.value);
      if (this.data) {
        const data = await this.certificateReservationService.updateCertificateReservation(this.data.id, this.certificateForm.value.companyId, this.certificateForm.value.reservationNo);
        if (data.status) {
          this.toastrService.success(data.message);
          this.certificateReservationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.certificateReservationService.createCertificateReservation(this.certificateForm.value.companyId, this.certificateForm.value.reservationNo);
        if (data.status) {
          this.toastrService.success(data.message);
          this.certificateReservationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      }
*/